import {createApp} from "petite-vue";
import initVideo from "./components/video";
import SimpleLightbox from "simple-lightbox";
import initPagination from "./components/pagination";
import Swiper from "swiper";
import {Keyboard, Navigation} from "swiper/modules";
import {initMap} from "./components/map";
import {isInViewport} from "./utils/is-in-viewport";
import initSearch from "./components/search";
import Cap from '@cap.js/widget';

import.meta.glob(['@images/**']);
import.meta.env.DEV && import("@styles/main.sass");

declare global {
    var Alpine: any;
    var Livewire: any;

    interface mapPinData {
        ID: number
        lat: string
        lng: string
        permalink: string
    }

    interface salonData {
        ID: number
        address: string
        claim: string
        email: string
        facebook_link: string
        instagram_link: string
        lat: string
        lng: string
        partner: string
        permalink: string
        phone: string
        subtitle: string
        thumbnail: string
        title: string
    }

    const salonsData: salonData[]
}

interface Header {
    opened: boolean;

    handleOpenedHeader(state: boolean): void;
}

const headerEl = document.querySelector<HTMLElement>('[data-header]'),
    headerScope: Header = {
        opened: false,

        handleOpenedHeader(state) {
            document.body.classList.toggle("u-hiddenOverflow", state);
        },
    };

if (headerEl) {
    createApp(headerScope).mount(headerEl);

}

//------------------------------------Why - šoupací fotka

(() => {
    const input = document.querySelector<HTMLInputElement>('.before-after-slider input[type="range"]');
    const figure = document.querySelector<HTMLElement>(".before-after-slider");

    if (input && figure) {
        input.addEventListener("input", () => {
            const value = Number(input.value);
            figure.style.setProperty("--rangeValue", value.toString());
        });
    }
})();

//----------------------------------------header změnšování

(() => {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    function onScroll() {
        if (window.scrollY > 0) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    }

    window.addEventListener('scroll', onScroll);
})();


//----------------------------------------Lightbox

(() => {

    const galleryElement = document.querySelector(".wp-block-gallery");
    new SimpleLightbox({
        elements: ".wp-block-gallery .wp-block-image > a",
    });
})();

(() => {

    const salonGalleryElement = document.querySelector(".wp-block-gallery");
    new SimpleLightbox({
        elements: ".Contact-photo > a",
    });
})();
//----------------------------------Swiper

(() => {
    const swiperContainer = document.querySelector("[data-swiper]") as HTMLElement | null;

    if (!swiperContainer) return;

    const swiperInstance = new Swiper(swiperContainer, {
        modules: [Keyboard, Navigation],
        slidesPerView: 4,
        slidesPerGroup: 1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        grabCursor: true,
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
        allowTouchMove: true,
    });
})();

(() => {
    const swiperInstaContainer = document.querySelector("[data-insta-swiper]") as HTMLElement | null;

    if (!swiperInstaContainer) return;

    const swiperInsta = new Swiper(swiperInstaContainer, {
        modules: [Keyboard],
        slidesPerView: "auto",
        slidesPerGroup: 1,
        grabCursor: true,
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
        allowTouchMove: true,
        loop: true,
    });
})();


//----------------------------------------LoggedIn sekce
(() => {
    const headerLogin = document.getElementById("header-login") as HTMLButtonElement | null;
    const headerLogged = document.getElementById("header-logged") as HTMLElement | null;
    const closeButton = document.getElementById("header-logged-close") as HTMLButtonElement | null;

    function toggleHeaderLogged(event: Event) {
        event.stopPropagation();
        if (headerLogged) headerLogged.classList.toggle("is-visible");
    }

    function handleOutsideClick(event: Event) {
        if (headerLogged && headerLogin && !headerLogged.contains(event.target as Node) && !headerLogin.contains(event.target as Node)) {
            headerLogged.classList.remove("is-visible");
        }
    }

    headerLogin?.addEventListener("click", toggleHeaderLogged);
    closeButton?.addEventListener("click", () => headerLogged?.classList.remove("is-visible"));
    document.addEventListener("click", handleOutsideClick);
})();

//--------------------------------------------show/hide password

(() => {
    const toggles = document.querySelectorAll(".FormPassword-toggle");

    toggles.forEach((toggle) => {
        toggle.addEventListener("click", () => {
            const input = toggle.previousElementSibling as HTMLInputElement | null;
            if (!input) return;

            const eyeIcon = toggle.querySelector(".icon-eye") as HTMLElement | null;
            const eyeSlashIcon = toggle.querySelector(".icon-eye-slash") as HTMLElement | null;

            if (input.type === "password") {
                input.type = "text";
                toggle.setAttribute("aria-label", "Skrýt heslo");
            } else {
                input.type = "password";
                toggle.setAttribute("aria-label", "Zobrazit heslo");
            }

            eyeIcon?.classList.toggle("hidden");
            eyeSlashIcon?.classList.toggle("hidden");
        });
    });
})();


//---------------------------------------scrollbehavior pro odkaz na HP

(() => {
    document.querySelectorAll('a[href*="#"]').forEach(anchor => {
        anchor.addEventListener("click", event => {
            const [page, targetId] = anchor.getAttribute("href").split("#");
            if (page && targetId) {
                event.preventDefault();
                localStorage.setItem("scrollToId", targetId);
                window.location.href = page;
            }
        });
    });

    const targetId = localStorage.getItem("scrollToId");
    if (targetId) {
        localStorage.removeItem("scrollToId");
        setTimeout(() => {
            const target = document.getElementById(targetId);
            if (target) window.scrollTo({
                top: target.getBoundingClientRect().top + window.scrollY - 192,
                behavior: "smooth"
            });
        }, 500);
    }
})();


(async () => {
    initSearch();
    initPagination();
    await initVideo();

    const mapEl = document.querySelector<HTMLElement>("[data-map]")
    mapEl && (document.body.classList.contains('archive') || isInViewport(mapEl, 4)) ? await initMap(mapEl)
        : window.addEventListener("scroll", async () => {
            isInViewport(mapEl, 4) && await initMap(mapEl)
        })

    const mapDialog = document.querySelector<HTMLDialogElement>('[data-map-dialog]')
    const mapDialogOpen = document.querySelector<HTMLButtonElement>('[data-map-dialog-open]')
    const mapDialogClose = document.querySelector<HTMLButtonElement>('[data-map-dialog-close]')
    const mapAside = document.querySelector<HTMLElement>('.SalonArchiveMap')

    if (mapDialog && mapDialogOpen && mapEl && mapAside) {
        const triggerMapResize = () => setTimeout(() => window.dispatchEvent(new Event('resize')), 50)

        mapDialogOpen.addEventListener('click', () => {
            mapDialog.insertBefore(mapEl, mapDialogClose)
            mapDialog.showModal()
            triggerMapResize()
        })

        mapDialogClose.addEventListener('click', () => mapDialog.close())

        mapDialog.addEventListener('close', () => {
            mapAside.appendChild(mapEl)
            triggerMapResize()
        })
    }
})();

//----------------------------------------O nás linky
(() => {
    const links = document.querySelectorAll<HTMLAnchorElement>('.CategoriesLink')

    links.forEach(link => {
        link.addEventListener('click', () => {
            links.forEach(l => l.classList.remove('CategoriesLink--active'))
            link.classList.add('CategoriesLink--active')
        })
    })
})();

//--------------------------------------------Footer open/close

(() => {
    function toggleDetailsOpen() {
        const details = document.querySelectorAll('.FooterMiddle-menu');
        const isDesktop = window.innerWidth >= 512;

        details.forEach(detail => {
            if (isDesktop) {
                detail.setAttribute('open', '');
            } else {
                detail.removeAttribute('open');
            }
        });
    }

    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(toggleDetailsOpen, 100);
    });

    window.addEventListener('resize', () => {
        setTimeout(toggleDetailsOpen, 100);
    });
})();

//----------------------------------------Newsletter popup + CTA
(() => {
    const dialog = document.querySelector<HTMLDialogElement>('[data-newsletter-popup]')
    const cta = document.querySelector<HTMLButtonElement>('[data-newsletter-cta]')
    if (!dialog) return

    const STORAGE_KEY = 'newsletter-popup-dismissed'

    const showCta = () => cta?.classList.remove('is-hidden')
    const hideCta = () => cta?.classList.add('is-hidden')

    if (localStorage.getItem(STORAGE_KEY)) {
        showCta()
    } else {
        setTimeout(() => dialog.showModal(), 5000)
    }

    const closeBtn = dialog.querySelector<HTMLButtonElement>('[data-newsletter-popup-close]')
    closeBtn?.addEventListener('click', () => dialog.close())

    dialog.addEventListener('close', () => {
        localStorage.setItem(STORAGE_KEY, '1')
        showCta()
    })

    const form = dialog.querySelector<HTMLFormElement>('form.hf-form')
    form?.addEventListener('hf-submitted', () => {
        localStorage.setItem(STORAGE_KEY, '1')
        setTimeout(() => {
            dialog.close()
            showCta()
        }, 2000)
    })

    cta?.addEventListener('click', () => {
        dialog.showModal()
    })
})();

(() => {
    const forms = document.querySelectorAll<HTMLFormElement>('form.hf-form');
    forms.forEach(async (form) => {
        let isCapVerified = false;
        let loadingInterval = null;
        const submitBtn = form.querySelector<HTMLButtonElement>('button[type="submit"]');

        const cap = new Cap({
            apiEndpoint: 'https://cap.tamtomy.cz/5f93618ba0/'
        });

        function submitForm(formEl: HTMLFormElement) {
            formEl.removeEventListener('submit', handleCapBeforeSubmit);
            formEl.requestSubmit();
        }

        function animateButton() {
            const currentContent = submitBtn.innerHTML;
            submitBtn.innerHTML = currentContent.length >= 5 ? '·' : currentContent + ' ' + '·';
        }

        async function handleCapBeforeSubmit(e: SubmitEvent) {
            if (isCapVerified) return;

            e.preventDefault();
            e.stopPropagation();

            submitBtn.dataset.originalText = submitBtn.innerHTML;
            submitBtn.style.width = window.getComputedStyle(submitBtn).width;
            submitBtn.style.pointerEvents = 'none';
            submitBtn.innerHTML = '·';
            loadingInterval = window.setInterval(animateButton, 500);

            const solver = await cap.solve();
            form.querySelector<HTMLInputElement>('input#cap-token').value = solver.token;

            isCapVerified = true;
            window.clearInterval(loadingInterval);
            loadingInterval = null;

            submitForm(form);
        }

        form.addEventListener('submit', handleCapBeforeSubmit);

        form.addEventListener('hf-submitted', () => {
            isCapVerified = false;
            form.querySelector<HTMLInputElement>('input#cap-token').value = '';
            submitBtn.style.pointerEvents = 'auto';
            submitBtn.innerHTML = submitBtn.dataset.originalText;
            form.addEventListener('submit', handleCapBeforeSubmit);
        });
    });
})();